export const DateIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 2.5H3C2.72386 2.5 2.5 2.72386 2.5 3V13C2.5 13.2761 2.72386 13.5 3 13.5H13C13.2761 13.5 13.5 13.2761 13.5 13V3C13.5 2.72386 13.2761 2.5 13 2.5Z"
      stroke="#866FC8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11 1.5V3.5"
      stroke="#866FC8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 1.5V3.5"
      stroke="#866FC8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.5 5.5H13.5"
      stroke="#866FC8"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 9C8.41421 9 8.75 8.66421 8.75 8.25C8.75 7.83579 8.41421 7.5 8 7.5C7.58579 7.5 7.25 7.83579 7.25 8.25C7.25 8.66421 7.58579 9 8 9Z"
      fill="#866FC8"
    />
    <path
      d="M10.75 9C11.1642 9 11.5 8.66421 11.5 8.25C11.5 7.83579 11.1642 7.5 10.75 7.5C10.3358 7.5 10 7.83579 10 8.25C10 8.66421 10.3358 9 10.75 9Z"
      fill="#866FC8"
    />
    <path
      d="M5.25 11.5C5.66421 11.5 6 11.1642 6 10.75C6 10.3358 5.66421 10 5.25 10C4.83579 10 4.5 10.3358 4.5 10.75C4.5 11.1642 4.83579 11.5 5.25 11.5Z"
      fill="#866FC8"
    />
    <path
      d="M8 11.5C8.41421 11.5 8.75 11.1642 8.75 10.75C8.75 10.3358 8.41421 10 8 10C7.58579 10 7.25 10.3358 7.25 10.75C7.25 11.1642 7.58579 11.5 8 11.5Z"
      fill="#866FC8"
    />
    <path
      d="M10.75 11.5C11.1642 11.5 11.5 11.1642 11.5 10.75C11.5 10.3358 11.1642 10 10.75 10C10.3358 10 10 10.3358 10 10.75C10 11.1642 10.3358 11.5 10.75 11.5Z"
      fill="#866FC8"
    />
  </svg>
);
